"use strict";
/**
 * this enum is only for channel orders.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["ApplePay"] = "APPLE_PAY";
    PaymentMethodType["Cash"] = "CASH";
    PaymentMethodType["CreditCard"] = "CREDIT_CARD";
    PaymentMethodType["GiftCart"] = "GIFTCARD";
    PaymentMethodType["GooglePay"] = "GOOGLE_PAY";
    PaymentMethodType["Paypal"] = "PAYPAL";
    PaymentMethodType["Unpaid"] = "UNPAID";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
//# sourceMappingURL=payment-method-type.js.map